import { render } from "./KryptonPaymentButton.vue?vue&type=template&id=19744844&lang=pug"
import script from "./KryptonPaymentButton.vue?vue&type=script&lang=js"
export * from "./KryptonPaymentButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__